import { Box, PressableIcon, Text } from '@bonanza-social/moonlight';
import { BottomSheet } from '@bonanza-social/navigation';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

function YourUniqueLink({
  playerExecutionCount,
  playerExecutionLimit,
}: {
  playerExecutionCount?: number;
  playerExecutionLimit?: number;
}) {
  const { t } = useTranslation('inviteFriends');

  const onPress = useCallback(() => {
    BottomSheet.open({
      namespace: 'inviteFriends',
      type: 'InviteStatus',
      data: {
        playerExecutionCount,
        playerExecutionLimit,
      },
    });
  }, [playerExecutionCount, playerExecutionLimit]);

  return (
    <Box flexDirection="row" justifyContent="space-between" alignItems="center">
      <Box
        backgroundColor="secondaryBackgroundDefault"
        flexDirection="row"
        alignItems="center"
        gap="space-100"
        paddingTop="space-050"
        paddingBottom="space-050"
        paddingLeft="space-200"
        paddingRight="space-200"
        borderRadius="radius-full"
      >
        <PressableIcon
          name="info"
          color="iconSecondary"
          width={22}
          height={22}
          onPress={onPress}
        />
        {playerExecutionLimit !== undefined ? (
          <Text variant="body-s" color="darkSurfacePrimary" textAlign="center">
            {t('unique_link_info', {
              invites: playerExecutionCount,
              left:
                playerExecutionCount !== undefined
                  ? playerExecutionLimit - playerExecutionCount
                  : 0,
            })}
          </Text>
        ) : (
          <Text variant="body-s" color="darkSurfacePrimary" textAlign="center">
            {t('unique_link_info_claimed', {
              invites: playerExecutionCount,
            })}
          </Text>
        )}
      </Box>
    </Box>
  );
}

export default YourUniqueLink;
